import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[fieldCapitalizeFirst]',
  standalone: false,
})
export class FieldCapitalizeFirstDirective {
  // Меняет первый символ на заглавный

  constructor() {}

  @HostListener('input', ['$event', '$event.target.value'])
  onInput(event: string, value: string): void {
    let val = event['target'].value;

    event['target'].value = val ? val.charAt(0).toUpperCase() + val.slice(1) : '';
  }

  @HostListener('paste', ['$event', '$event.target.value'])
  onPaste(event: string, value: string): void {
    let val = event['target'].value;

    event['target'].value = val ? val.charAt(0).toUpperCase() + val.slice(1) : '';
  }
}
